export default __webpack_public_path__ + "static/media/forkify.d80bb8ff.png";